import { SET_ITEMS } from '../mutation-types'
import axios from 'axios'

const SET_CHART = 'SET_CHART'

export default {
    namespaced: true,

    state: {
        data: [],
        meta: null,

        chart: []
    },

    actions: {
        async fetchChart({ commit }, { params }) {
            try {
                let response = await axios.get(`api/vends-chart`, { params })
                commit(SET_CHART, response.data)
            } catch (error) {
                return false
            }
        },

        async fetchAll({ commit }, { params }) {
            try {
                let response = await axios.get(`api/vends`, { params })
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }
        }
    },

    mutations: {
        [SET_ITEMS](state, { data, meta }) {
            state.data = data
            state.meta = meta
        },

        [SET_CHART](state, chart) {
            state.chart = chart
        }
    }
}
